import React from 'react';
import { Box, Typography, Stack, TextField } from '@mui/material';

interface BasicInfoSectionProps {
  priority: number;
  modifier: string;
  onModifierChange: (value: string) => void;
}

export const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({
  priority,
  modifier,
  onModifierChange,
}) => (
  <Box>
    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#1e293b' }}>
      Basic Information
    </Typography>
    <Stack direction="row" spacing={2}>
      <TextField
        label="Priority"
        type="number"
        size="small"
        value={priority}
        sx={{ width: 120 }}
        required
        helperText="Auto-assigned next number"
        InputProps={{ readOnly: true }}
        disabled
      />
      <TextField
        label="Modifier"
        size="small"
        value={modifier}
        onChange={(e) => onModifierChange(e.target.value)}
        sx={{ width: 120 }}
      />
    </Stack>
  </Box>
);
